// extracted by mini-css-extract-plugin
export var container = "section-title-module--container--8sHXr";
export var title = "section-title-module--title--xgARz";